import dataSelect from '@store/dataForSelect/reducers';

import { exams_category_select } from '../../configs/constants';

export default dataSelect(exams_category_select);
